import { useLocation } from "react-router";

import { AddPlayerForm } from "../session-players/AddPlayerForm";
import { DevicesSessionSideBar } from "./devices/DevicesSessionSideBar";

export const SessionsSideBar = () => {
  const { pathname } = useLocation();

  const id = pathname.split("/")[2];

  return !id ? <AddPlayerForm /> : <DevicesSessionSideBar />;
};
